/**
 * JsonLd Component - SEO Schema.org structured data
 * 
 * This component renders JSON-LD structured data for SEO optimization.
 * It's compatible with SSR (Server-Side Rendering) and follows Google's
 * structured data guidelines.
 * 
 * @see https://developers.google.com/search/docs/appearance/structured-data
 */

import React from 'react';
import PropTypes from 'prop-types';

const JsonLd = ({ data }) => {
  if (!data) return null;
  
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ 
        __html: JSON.stringify(data, null, 0) 
      }}
    />
  );
};

JsonLd.propTypes = {
  data: PropTypes.object.isRequired,
};

export default JsonLd;
